export default __webpack_public_path__ + "static/media/fon-page-top.74743266.png";